import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

export interface SurchargeInfo {
  currency_code: string;
  price: number | string;
}

interface Props {
  handleFlagChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  surchargeInfo: SurchargeInfo;
  is_refunded_surcharge?: boolean | null;
}

export default function SurchargeToggle({ handleFlagChange, surchargeInfo, is_refunded_surcharge }: Props) {
  return (
    <Box id="SurchargeToggle">
      <Typography>
        Should the surcharge {surchargeInfo.currency_code} {surchargeInfo.price} be refunded to customer?
      </Typography>

      <Stack>
        <Box>
          <input
            type="radio"
            key="yes"
            name="is_refunded_surcharge"
            className="T-is-refunded-surcharge-yes"
            value="1"
            onChange={handleFlagChange}
            checked={is_refunded_surcharge === true}
          />
          <label>Yes</label>
        </Box>
        <Box>
          <input
            type="radio"
            key="no"
            name="is_refunded_surcharge"
            className="T-is-refunded-surcharge-no"
            value="0"
            onChange={handleFlagChange}
            checked={is_refunded_surcharge === false}
          />
          <label>No</label>
        </Box>
      </Stack>
    </Box>
  );
}
